import axios from 'axios';
import UrlsUtil from '../../utils/url.util';

const apiBaseUrl = UrlsUtil.determineApiBaseUrl(window);
const apiKey = `${process.env.REACT_APP_APIKEY}`;

export default class ArchiveService {
  static getAll = async (): Promise<any> => {
    const url = `${apiBaseUrl}/api/watchdog/all`;
    return await axios.get(url, { headers: { 'apiKey': apiKey } });
  };
};